export const DEMO_RESET_EVENT = "yatta:demo-reset";

export function resetDemoSession() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(DEMO_RESET_EVENT));
  }
}

export function subscribeDemoReset(callback: () => void) {
  if (typeof window === "undefined") return () => undefined;
  window.addEventListener(DEMO_RESET_EVENT, callback);
  return () => window.removeEventListener(DEMO_RESET_EVENT, callback);
}
